// Contador de palabras en vivo para los textareas con mínimo obligatorio, y el
// botón de aceptar deshabilitado mientras a ALGUNO le falte. Aceptar es
// definitivo (ya no se puede editar) y el servidor lo rechaza si algún campo
// no llega al mínimo, así que dejarlo habilitado solo servía para que el
// alumno confirmara un "esto es definitivo" y se topara con el error después.
//
// "Guardar" nunca se toca: guardar un borrador corto tiene que seguir siendo
// posible, es justo para lo que sirve.
//
// El botón vive FUERA del textarea (abajo del formulario, junto a Guardar) y
// los campos con mínimo son varios, así que esto se agrupa por formulario: los
// contadores son de cada textarea, el botón depende de todos. La validación de
// verdad sigue en el servidor, ver CitasSemanalesController#validar_minimo.

const contarPalabras = (texto) => texto.trim().split(/\s+/).filter(Boolean).length

export function initContadorPalabras() {
  const grupos = new Map()
  document.querySelectorAll("textarea[data-min-palabras]").forEach((textarea) => {
    const clave = textarea.form || null
    if (!grupos.has(clave)) grupos.set(clave, [])
    grupos.get(clave).push(textarea)
  })

  grupos.forEach((textareas, form) => {
    const boton = form ? form.querySelector("[data-contador-submit]") : null

    const actualizar = () => {
      let completos = true

      textareas.forEach((textarea) => {
        const minimo = parseInt(textarea.dataset.minPalabras, 10)
        const n = contarPalabras(textarea.value)
        const falta = minimo - n
        if (falta > 0) completos = false

        const contador = textarea.parentElement.querySelector("[data-contador-palabras]")
        if (!contador) return

        contador.textContent = falta > 0
          ? `Llevas ${n} de ${minimo} palabras (te faltan ${falta}).`
          : `${n} palabras — cumples el mínimo de ${minimo}.`
        contador.className = `text-xs mt-1 ${falta > 0 ? "text-error" : "text-success"}`
      })

      if (boton) {
        boton.disabled = !completos
        // Sin esto el botón gris no explica nada; los contadores en rojo están
        // más arriba y pueden haber quedado fuera de la pantalla.
        boton.title = completos ? "" : "Completa el mínimo de palabras en los campos marcados con *."
      }
    }

    textareas.forEach((textarea) => textarea.addEventListener("input", actualizar))
    actualizar()
  })
}
